import { Box, styled } from "@mui/material";
import { APP_COLOR } from "../../theme";

export const styles = {
  audioFileDetailsMainContainer: {
    display: "flex",
    margin: "20px",
    boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.7)",
    padding: "20px",
    borderRadius: "10px",
  } as const,
  detailsContainer: {
    marginLeft: "20px",
    width: "400px",
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    marginTop: "10px",
  } as const,
  buttonsMainContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "space-between",
  } as const,
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    height: "50px",
  } as const,
  typographyContainer: {
    display: "flex",
    gap: "10px",
  } as const,
  text: {
    fontWeight: "bold",
  } as const,
  avatar: {
    backgroundColor: APP_COLOR,
    cursor: "pointer",
  } as const,
  artworkImage: {
    width: "300px",
    height: "300px",
    objectFit: "cover",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  }as const,
  artworkImageContainer: {
    width: "300px",
    margin: "0 auto",
  }as const,
  artworkMainContainer: {
    display: "flex",
    justifyContent: "center",
  }as const
};

export const MainContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width:'100%',
  margin: "20px",
  boxShadow: "0px 5px 10px 0px rgba(0,0,0,0.7)",
  padding: "20px",
  borderRadius: "10px",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    justifyContent: "center",
  },
}));

export const ArtWorkContainer = styled(Box)(({ theme }) => ({
  boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.8)",
  padding: "20px",
  display: "flex",
  justifyContent: "center",
  gap: "40px",
  paddingLeft:'30px',
  paddingRight:'30px',
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap:'20px'
  },
}));


export const DetailsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  marginTop: "10px",
  [theme.breakpoints.down("md")]: {
    gap:'5px'
  },
}));